import { ref, onBeforeUnmount } from 'vue';

export const usePopupToast = () => {
  const toast = ref('');
  let timer = null;

  const avisar = msg => {
    toast.value = msg;
    clearTimeout(timer);
    timer = setTimeout(() => {
      toast.value = '';
    }, 3200);
  };

  onBeforeUnmount(() => clearTimeout(timer));

  return { toast, avisar };
};
